import { useEffect, useRef, useState } from 'react';

import { GTMEventLogger } from 'utils/GTMEventLogger';

import { GTMEvents } from 'constants/enums';

interface UseTrackFormProps {
  formId: string;
  incompleteEvent: GTMEvents;
  submittedEvent?: GTMEvents;
}

export const useTrackForm = ({
  formId,
  incompleteEvent,
  submittedEvent
}: UseTrackFormProps) => {
  const [isFormStarted, setIsFormStarted] = useState(false);
  const isFormSubmitted = useRef(false);

  useEffect(() => {
    const formElement = document.getElementById(formId);

    if (!formElement) {
      console.warn(`Form with ID "${formId}" not found.`);
      return;
    }

    const handleInput = () => {
      if (!isFormStarted) {
        setIsFormStarted(true);
      }
    };

    const handleSubmit = () => {
      isFormSubmitted.current = true;
      if (submittedEvent) {
        GTMEventLogger(submittedEvent);
      }
    };

    formElement.addEventListener('input', handleInput);
    formElement.addEventListener('submit', handleSubmit);

    return () => {
      formElement.removeEventListener('input', handleInput);
      formElement.removeEventListener('submit', handleSubmit);

      if (isFormStarted && !isFormSubmitted.current) {
        GTMEventLogger(incompleteEvent);
      }
    };
  }, [formId, incompleteEvent, submittedEvent]);
};
